import * as ImagePicker from 'expo-image-picker';
import { compress, compressVideo } from '../services';

const DEFAULT_OPTIONS: ImagePicker.ImagePickerOptions = {
	base64: true,
	exif: true,
};

const useImagePicker = (
	onChange: (result: ImagePickerResult) => Promise<void> | void,
	options?: ImagePicker.ImagePickerOptions & { compress?: boolean },
) => {
	return async (source: ImagePickerSource = 'gallery') => {
		try {
			await askPermissions(source);
		} catch (error) {
			if (error instanceof Error) {
				alert(error.message);
			}
		}

		const pickImages =
			source === 'gallery' ? ImagePicker.launchImageLibraryAsync : ImagePicker.launchCameraAsync;
		const pickerResult = await pickImages({ ...DEFAULT_OPTIONS, ...options });
		if (pickerResult.canceled) {
			return;
		}

		const [firstImage] = pickerResult.assets;

		if (!options?.compress) {
			return onChange(firstImage);
		}

		const compressedImage =
			firstImage.type === 'video'
				? { ...firstImage, uri: await compressVideo(firstImage.uri) }
				: await compress(firstImage.uri);

		return onChange(compressedImage);
	};
};

async function askPermissions(source: ImagePickerSource) {
	if (source === 'gallery') {
		return;
	}

	const permissionResult = await ImagePicker.requestCameraPermissionsAsync();

	if (!permissionResult.granted) {
		throw Error(`Permission to access camera is required!`);
	}
}

type ImagePickerResult = ImagePicker.ImagePickerAsset;
type ImagePickerSource = 'camera' | 'gallery';

export { useImagePicker, ImagePickerResult };
